var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlechaIzquierda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8313 12L15.7813 16.95L14.3673 18.364L8.00325 12L14.3673 5.63599L15.7813 7.04999L10.8313 12Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaIzquierda);
export default __webpack_public_path__ + "static/media/flechaIzquierda.b920065bea94dd3c77bbb790d4efe324.svg";
export { ForwardRef as ReactComponent };